import React, { useRef, useEffect, useState, useContext } from "react";
import { useHistory, useLocation } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import ApiService from "../../_services/ApiService";
import { ILoader } from "../../_components/iloader/iloader";
import { AppPropertiesContext } from "../../contexts/app-properties.context";
import Config from "../../_config/config";
import "./admit-card.styles.css";

const ADMITCARD_DETAILS = [{ copy: null }]; //{ copy: "OFFICE COPY" }

const AdmitCard = () => {
  const history = useHistory();
  const { getCenterAdressById } = useContext(AppPropertiesContext);
  const location = useLocation();
  const { state } = location;
  const { testDetails, testTime, testName, centreName, centreAddress } =
    state || {};

  const [fetchedAdmitCardDetails, setAdmitCardDetails] = useState({});

  const centreAddressById = getCenterAdressById(
    fetchedAdmitCardDetails?.jsonField1
      ? fetchedAdmitCardDetails?.jsonField1["form-id"]
      : null,
    fetchedAdmitCardDetails?.jsonField1?.centreId
  );

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const fetchAdmitCardDetails = async () => {
      if (testDetails) return;
      setShowLoader(true);
      const res = await ApiService.fetchAdmitCardDetails();
      const newAdmitCardDetails = res.data;
      console.log(newAdmitCardDetails);
      setShowLoader(false);
      setAdmitCardDetails(newAdmitCardDetails);
    };

    fetchAdmitCardDetails();
  }, []);

  const admitCardDetails = ADMITCARD_DETAILS;
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(user);

  const container = useRef(null);
  useEffect(() => {
    if (container) {
      // window.print();
    }
  }, []);

  const printAdmitCard = () => {
    window.print();
  };

  return (
    <>
    <div className={`module-header-step2 test-list-default-portlet`}>
        <div className="">
          <div className="back">
            <FontAwesomeIcon icon={faArrowLeft} onClick={history.goBack} />
          </div>
          <h4>Admit Card</h4>
        </div>
      </div>

      <ILoader isShow={showLoader} loadingText="please wait.." />
      <div className="admit-card-download-container">
        <button onClick={printAdmitCard} className="btn btn-success">
          Download
        </button>
      </div>

      

      {admitCardDetails.map((admitcard, index) => (
        <div
          ref={container}
          key={index}
          className={`admit-card-container ${index !== 0 ? "page-break" : ""}`}
        >
          {admitcard?.copy ? (
            <h3 className="admit-card-heading-3">{admitcard?.copy}</h3>
          ) : null}
          <div>
            <div className="admit-card-header">
              <img
                className="admit-card-logo"
                src={`http://webfront.edusquares.com/${Config.siteTitle}/files/logos/admitcardlogo.png`}
                alt="logo"
              />
              <div>
                <h5 className="admit-card-heading-5 admit-bigger-h5">
                  ADMIT CARD{" "}
                </h5>
                <h5 className="admit-card-heading-5">for your offline exams</h5>
              </div>
            </div>
            <div className="admit-card-body">
              <div>
                <div className="admit-card-details">
                  <div className="admit-card-border admit-card-heading-7">
                    Admit Card No.
                  </div>
                  <div className="admit-card-border admit-card-content">
                    {fetchedAdmitCardDetails?.studentCode ||
                      testDetails?.AdmitCardNumber}
                  </div>
                </div>
                <div className="admit-card-details">
                  <div className="admit-card-border admit-card-heading-7">
                    Name of the Candidate
                  </div>
                  <div className="admit-card-border admit-card-content">
                    {fetchedAdmitCardDetails?.jsonField1?.studentName ||
                      user?.username}
                  </div>
                </div>
                {/* <div className="admit-card-details">
              <div className="admit-card-border admit-card-heading-7">
                Date Of Birth
              </div>
              <div className="admit-card-border admit-card-content">{}</div>
            </div> */}
                {/* <div className="admit-card-details">
              <div className="admit-card-border admit-card-heading-7">
                Gender
              </div>
              <div className="admit-card-border admit-card-content">{}</div>
            </div>
            <div className="admit-card-details">
              <div className="admit-card-border admit-card-heading-7">
                Parent/ Guardian Name
              </div>
              <div className="admit-card-border admit-card-content">{}</div>
            </div> */}
                <div className="admit-card-details">
                  <div className="admit-card-border admit-card-heading-7">
                    Centre Name
                  </div>
                  <div className="admit-card-border admit-card-content">
                    { centreName || fetchedAdmitCardDetails?.jsonField1?.centreId ||
                      testDetails?.Venue}
                  </div>
                </div>
                <div className="admit-card-details">
                  <div className="admit-card-border admit-card-heading-7">
                    Center Address
                  </div>
                  <div className="admit-card-border admit-card-content">
                    {centreAddress || centreAddressById}
                  </div>
                </div>
                <div className="admit-card-details">
              <div className="admit-card-border admit-card-heading-7">
                Test Details
              </div>
              <div className="admit-card-border admit-card-content">{testName} on {testTime}</div>
            </div>
                {/* 
            <div className="admit-card-details">
              <div className="admit-card-border admit-card-heading-7">
                Mobile & Email Id
              </div>
              <div className="admit-card-border admit-card-content">{`${user?.mobileNumber} & ${user?.emailId}`}</div>
            </div> */}
              </div>
              {/* <div className="admit-card-border admit-card-img-wrapper">
            <img
              className="admit-card-user-img"
              src="https://tuningfork-live.s3.amazonaws.com/nttf2/files/blankAvatar.PNG"
              alt="user img"
            />
          </div> */}
            </div>
            {/* <div className="admit-card-body">
              <div>
                <div className="center-text admit-card-border admit-card-content">
                  For Office Use Only
                </div>
                <div className="admit-card-details">
                  <div className="admit-card-border admit-card-heading-7">
                    Issuing Authority Name, Designation & Office Seal
                  </div>
                  <div className="admit-card-border admit-card-content"></div>
                </div>
              </div> */}
            {/* <div className="admit-card-border admit-card-padd-l">
            <div className="admit-card-bold">Examiner</div>
            <div>Name:</div>
            <div>Sign:</div>
            <div>Date:</div>
          </div> */}
            {/* </div> */}
          </div>
          <div className="admit-card-instruction">
            <span className="admit-card-bold">
              Instruction to the Candidate
            </span>
            <ol>
              <li>
                Student need to print and carry the Admit card to the exam
                centre.
              </li>
              <li>
                Student will not be allowed to appear in the exam without admit
                card
              </li>
              <li>
                Student should report the examination centre 30 minutes before
                the exam start time
              </li>
              <li>
                Aadhar Card is to be brought at the time of the Exam for
                validation purpose.
              </li>
              <li>
                No Student will be allowed to enter the exam after 15 mins of
                the start of the Exam.
              </li>
              <li>
                No mobile phones and electronic gadgets are permitted at the
                time of the exam
              </li>
            </ol>
          </div>
        </div>
      ))}
    </>
  );
};

export default AdmitCard;
